// src/pages/safety/Create.jsx
import React, { useState } from "react";
import { useNavigate } from "react-router-dom";

const Card = ({ title, desc, onClick }) => (
  <button
    onClick={onClick}
    className="block w-full text-left border rounded-xl p-4 hover:bg-gray-50 transition"
  >
    <div className="text-lg font-semibold">{title}</div>
    <div className="text-sm text-gray-500 mt-1">{desc}</div>
  </button>
);

export default function SafetyCreate() {
  const navigate = useNavigate();
  const projectId = localStorage.getItem("projectId");

  // 자유양식 모달
  const [openUserModal, setOpenUserModal] = useState(false);
  const [userFormType, setUserFormType] = useState("ISC"); // SPP | ISC | RAS | INC

  // 공통 Form 경로로 이동
  const goForm = (formType, mode = 1) =>
    navigate(`/project/${projectId}/safety/form/${mode}?form_type=${formType}`);

  // 1️⃣ 안전계획 (SPP)
  const handleSPP = () => goForm("SPP", 1);

  // 2️⃣ 안전 점검 (통합) → 일정/결과 등록
  const handleChecklist = () => goForm("ISC", 1);

  // 3️⃣ SCAR (시정조치)
  const handleSCAR = () => goForm("CAR", 1);

  // 4️⃣ 위험성평가 (RAS)
  const handleRAS = () => goForm("RAS", 1);

  // 5️⃣ 사고 이력 (INC)
  const handleINC = () => goForm("INC", 1);

  // 6️⃣ 자유양식(사용자 템플릿)
  // const confirmUserTemplate = () => {
  //   const t = (userFormType || "SPP").toUpperCase();
  //   goForm(t, 2); // 사용자 템플릿은 mode=2
  // };

  return (
    <div className="p-4 space-y-6">
      <h2 className="text-xl font-bold">문서 만들기</h2>

      <div className="grid gap-4 md:grid-cols-3">
        <Card
          title="SCAR 작성"
          desc="불합격 또는 미조치 항목에 대한 시정조치서"
          onClick={handleSCAR}
        />
        <Card
          title="안전 점검 일정/결과 등록"
          desc="점검 일정 및 결과를 하나의 문서로 관리"
          onClick={handleChecklist}
        />
        <Card
          title="안전 계획서 업로드"
          desc="사업장 안전관리 계획서 업로드"
          onClick={handleSPP}
        />
        <Card
          title="위험성 평가서"
          desc="위험도 산정 및 개선계획"
          onClick={handleRAS}
        />
        <Card
          title="사고 보고서 작성"
          desc="사고 이력을 등록하고 통계를 제공합니다."
          onClick={handleINC}
        />
        {/* <Card
          title="자유양식 (사용자 템플릿)"
          desc="문서종류 선택 후 사용자 템플릿으로 작성"
          onClick={() => setOpenUserModal(true)}
        /> */}
      </div>

      <div className="text-sm text-gray-500">
        * 생성 후 상세 화면에서 상태(임시저장/승인/종결) 등을 설정할 수
        있습니다.
      </div>

      {/* 자유양식 문서종류 선택 모달 */}
      {/* {openUserModal && (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/30">
          <div className="w-full max-w-md rounded-2xl bg-white p-4 shadow-xl">
            <div className="text-lg font-semibold">
              자유양식 - 문서종류 선택
            </div>
            <div className="text-sm text-gray-600 mt-1">
              사용자 템플릿(수정 가능)으로 작성할 문서 종류를 선택하세요.
            </div>

            <div className="mt-4">
              <label className="block text-sm mb-1 text-gray-700">
                문서 종류
              </label>
              <select
                className="w-full rounded-xl border px-3 py-2 text-sm"
                value={userFormType}
                onChange={(e) => setUserFormType(e.target.value)}
              >
                <option value="SPP">안전 계획서</option>
                <option value="ISC">안전 점검 일정</option>
                <option value="CAR">시정 조치 요청서(SCAR)</option>
                <option value="RAS">위험성 평가</option>
                <option value="INC">사고 보고서</option>
              </select>
            </div>

            <div className="mt-4 flex justify-end gap-2">
              <button
                className="rounded-xl border px-3 py-2 text-sm hover:bg-gray-50"
                onClick={() => setOpenUserModal(false)}
              >
                취소
              </button>
              <button
                className="rounded-xl bg-indigo-600 px-3 py-2 text-sm text-white hover:bg-indigo-700"
                onClick={() => {
                  setOpenUserModal(false);
                  confirmUserTemplate();
                }}
              >
                작성하기
              </button>
            </div>
          </div>
        </div>
      )} */}
    </div>
  );
}
